export default __webpack_public_path__ + "static/media/desk_preland_5.b6139f61.jpg";